import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_MenuExpanded = _resolveComponent("MenuExpanded")
  const _component_Collapse = _resolveComponent("Collapse")
  const _component_Mask = _resolveComponent("Mask")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Collapse, {
      class: "collapse",
      horizontal: "",
      "keep-alive": "",
      open: $data.open,
      onClick: _cache[3] || (_cache[3] = $event => ($data.open = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MenuExpanded, {
          items: $options.c_items,
          class: "mobile-menu",
          onFeedbackOpen: _cache[1] || (_cache[1] = $event => ($data.open = false)),
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, {
          collapse: _withCtx(() => [
            _createVNode(_component_IconAsButton, {
              icon: "x-close",
              size: "3rem",
              onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($data.open = false), ["stop"]))
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["items"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"]),
    (_ctx.mounted)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#modals"
        }, [
          _createVNode(_component_Mask, {
            show: $data.open,
            onClick: _cache[4] || (_cache[4] = $event => ($data.open = false))
          }, null, 8 /* PROPS */, ["show"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}